import type { AppState } from '@store/types'

type Props = { workspaceId?: string; folderId?: string }

export const selectWorkspaceId = (_: AppState, props: Props) =>
  props.workspaceId

export const selectFolderId = (_: AppState, props: Props) => props.folderId
